export enum PublicRoutes {
    Home = '',
  }
  